document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".efi-tab-btn");
  const panels = document.querySelectorAll(".efi-panel");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const target = tab.dataset.tab;

      panels.forEach((panel) => {
        panel.classList.toggle("active", panel.dataset.panel === target);
      });
    });
  });
});